import { motion } from 'framer-motion';
import { EXPAND_ANIMATION } from '../constants';

interface ExpandChevronProps {
  isExpanded: boolean;
}

export function ExpandChevron({ isExpanded }: ExpandChevronProps) {
  return (
    <motion.div
      animate={{ rotate: isExpanded ? 90 : 0 }}
      transition={{ duration: EXPAND_ANIMATION.duration, ease: EXPAND_ANIMATION.ease }}
      className="flex items-center justify-center w-5 h-5 bg-white rounded-md flex-shrink-0"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.5 5L12.5 10L7.5 15"
          stroke="#45556C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </motion.div>
  );
}
